import { useState } from "react";
import { Droppable } from "@hello-pangea/dnd";
import { Grid, useMediaQuery } from "@mui/material";
import ContainerLayout from "../configs/ContainerLayout";
import widgetsSelected from "../configs/widgetsSelection";

function Center({
  masterContainerId,
  cellData,
  cellId,
  setLayoutData,
  handleDeleteWidget,
  widgetsDataObj,
  handleBreadcrumbs,
  widgetsDataObj2,
  setWidgetsDataObj2,
  isEditMode,
  isAdmin,
}) {
  const widgets = widgetsSelected(
    masterContainerId,
    cellId,
    handleDeleteWidget,
    cellData,
    setLayoutData,
    "vertical",
    widgetsDataObj,
    handleBreadcrumbs,
    widgetsDataObj2,
    isEditMode,
    isAdmin,
  );

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);

  const droppableId = `${masterContainerId}/${cellId}`;

  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <Grid
          item
          xs={cellData.width.xs || 12}
          sm={cellData.width.sm || cellData.width.xs || 12}
          md={cellData.width.md || cellData.width.sm || cellData.width.xs || 12}
          lg={
            cellData.width.lg ||
            cellData.width.md ||
            cellData.width.sm ||
            cellData.width.xs ||
            12
          }
          xl={
            cellData.width.xl ||
            cellData.width.lg ||
            cellData.width.md ||
            cellData.width.sm ||
            cellData.width.xs ||
            12
          }
          position="relative"
          border={isEditMode && "1px solid #ccc"}
          borderRadius={3}
          minHeight={
            matches &&
            (widgets.length > 0 || !isEditMode ? "" : cellData.height)
          }
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          <ContainerLayout
            isPopUpOpen={isPopUpOpen}
            setIsPopUpOpen={setIsPopUpOpen}
            masterContainerId={masterContainerId}
            cellId={cellId}
            setLayoutData={setLayoutData}
            widgets={widgets}
            setWidgetsDataObj2={setWidgetsDataObj2}
            isEditMode={isEditMode}
            isAdmin={isAdmin}
          />
          {provided.placeholder}
        </Grid>
      )}
    </Droppable>
  );
}

export default Center;
